@import '../../../../ui/gzDialog/view/windowShared.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.footer__container {
  @include windowFooter;

  margin-top: auto;
  justify-content: space-between;
}

.form-field-input {
  width: var(--form-field-label-width);
  margin-top: calc(var(--spacer) * 1.5);
}

#size-helper-wrapper {
  width: 240px;
  font-size: var(--body-size);
  padding: 0 var(--spacer);
  background-color: transparent;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
  color: var(--grey-layout-201-disabled-text);
  text-align: left;
  line-height: 16px;
}

.disclaimer-title {
  margin-top: calc(var(--spacer));
  margin-bottom: calc(var(--spacer));
  margin-left: calc(var(--spacer) * 5);
  color: var(--chart-300-icon-buttons);
}

.disclaimer {
  width: 846px;
  margin-left: calc(var(--spacer) * 5);
  justify-content: start;

  .disclaimer-text{
    font-size: 12px;
    color: var(--body-text-arrows-400);
  }
}

gz-collapsable-container::part(button-show-more) {
  justify-content: start;
}
